import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

export const emailHubSubscriptionApi = {
  cancel: (reason: string, reasonDescription: string) =>
    reactQueryPost(
      internalApi.emailHubSubscription.cancel(reason, reasonDescription),
    ),
};
